// LotoScanner.js - Cập nhật select nhóm thông minh + nhóm trong modal (17/12/2025)

import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import './LotoScanner.css';

// === CẤU HÌNH GEMINI API ===
const API_KEY = process.env.REACT_APP_GEMINI_API_KEY_FOR_LOTO;
const GEMINI_MODEL = 'gemini-2.5-flash';
const GEMINI_ENDPOINT = `https://generativelanguage.googleapis.com/v1/models/${GEMINI_MODEL}:generateContent?key=${API_KEY}`;

// Danh sách 6 vòng cố định theo màu
const ROUNDS = [
  { value: 'Vòng Xanh Dương', label: 'Vòng Xanh Dương', color: '#e3f2fd', border: '#2196f3' },
  { value: 'Vòng Xanh Lá', label: 'Vòng Xanh Lá', color: '#e8f5e9', border: '#4caf50' },
  { value: 'Vòng Vàng', label: 'Vòng Vàng', color: '#fffde7', border: '#ffeb3b' },
  { value: 'Vòng Hồng', label: 'Vòng Hồng', color: '#fce4ec', border: '#e91e63' },
  { value: 'Vòng Sữa Gạo', label: 'Vòng Sữa Gạo', color: '#f5f5dc', border: '#d2b48c' },
  { value: 'Vòng Đỏ', label: 'Vòng Đỏ', color: '#ffebee', border: '#f44336' }
];

const ADD_NEW_GROUP_OPTION = '-- Thêm nhóm mới --';

// === LOCALSTORAGE KEYS ===
const STORAGE_KEYS = {
  TICKETS: 'loto_tickets',
  CALLED_NUMBERS: 'loto_called_numbers',
  CUSTOM_GROUPS: 'loto_custom_groups'
};

// --- HÀM TẢI ẢNH QR ---
const downloadQR = async () => {
  const imageUrl = "https://api.vietqr.io/image/970416-7624897-xvYC6jO.jpg?accountName=DO%20NHAT%20TAI";
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = "QR_Ung_Ho_Loto_AI.png"; // Ép trình duyệt phải tải xuống
    document.body.appendChild(link);
    link.click();

    // Dọn dẹp bộ nhớ
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Không thể tải ảnh trực tiếp:", error);
    // Phương án dự phòng: Mở trong tab mới nếu fetch bị lỗi CORS
    window.open(imageUrl, '_blank');
  }
};

// === HÀM HỖ TRỢ ===
const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = (error) => reject(error);
  });
};

const scanLotoTicketWithGemini = async (imageFile) => {
  const base64Image = await getBase64(imageFile);

  const requestBody = {
    contents: [
      {
        parts: [
          {
            text: "Đây là ảnh vé lô tô Giáng Sinh Việt Nam dạng lưới 3x3 (9 số hai chữ số). "
              + "Vé có nền màu đặc trưng để phân biệt vòng chơi. Có 6 vòng với màu sau:\n"
              + "- Xanh dương\n- Xanh lá\n- Vàng\n- Hồng\n- Sữa gạo (be nhạt)\n- Đỏ\n\n"
              + "Nhiệm vụ của bạn:\n"
              + "1. Trích xuất đúng 9 số theo thứ tự từ trái sang phải, từ trên xuống dưới.\n"
              + "2. Xác định vòng chơi dựa vào màu nền chính của vé (màu nổi bật nhất).\n\n"
              + "Trả về CHỈ MỘT đối tượng JSON với định dạng sau, không thêm giải thích hay markdown:\n"
              + "{\n"
              + "  \"numbers\": [\"01\",\"23\",\"45\",\"67\",\"89\",\"12\",\"34\",\"56\",\"78\"],\n"
              + "  \"round\": \"Vòng Xanh Lá\"\n"
              + "}\n\n"
              + "Chỉ chọn đúng một trong các giá trị vòng sau: "
              + ROUNDS.map(r => `"${r.value}"`).join(", ") + ".\n"
              + "Mỗi số phải là chuỗi 2 chữ số (pad '0' nếu cần)."
          },
          {
            inlineData: {
              mimeType: imageFile.type || 'image/jpeg',
              data: base64Image
            }
          }
        ]
      }
    ],
    generationConfig: {
      temperature: 0.1,
      topP: 0.8,
      topK: 40,
      maxOutputTokens: 2048
    }
  };

  const response = await fetch(GEMINI_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Lỗi API: ${response.status} - ${errorText}`);
  }

  const data = await response.json();
  if (!data.candidates || data.candidates.length === 0) {
    throw new Error('Không nhận được phản hồi từ AI');
  }

  let text = data.candidates[0].content.parts[0].text.trim();
  text = text.replace(/^```json\s*|```$/g, '').trim();

  try {
    const result = JSON.parse(text);
    if (!result.numbers || !Array.isArray(result.numbers) || !result.round) {
      throw new Error('Thiếu numbers hoặc round');
    }
    const formattedNumbers = result.numbers.map(n => String(n).padStart(2, '0'));
    const validRound = ROUNDS.find(r => r.value === result.round) ? result.round : 'Vòng Xanh Dương';
    return { numbers: formattedNumbers, round: validRound };
  } catch (parseError) {
    throw new Error('Phản hồi không đúng định dạng: ' + text);
  }
};

const handleBatchOCRWithMultipleTickets = async (imageFile) => {
  const base64Image = await getBase64(imageFile);

  const requestBody = {
    contents: [
      {
        parts: [
          {
            text: "Đây là ảnh chứa MỘT HOẶC NHIỀU vé lô tô Giáng Sinh Việt Nam, mỗi vé là lưới 3x3 (9 số hai chữ số). "
              + "Các vé có thể nằm cạnh nhau, trên dưới nhau, hoặc sắp xếp ngẫu nhiên trong ảnh.\n"
              + "Mỗi vé có nền màu đặc trưng để phân biệt vòng chơi. Có 6 vòng với màu sau:\n"
              + "- Xanh dương\n- Xanh lá\n- Vàng\n- Hồng\n- Sữa gạo (be nhạt)\n- Đỏ\n\n"
              + "Nhiệm vụ của bạn:\n"
              + "1. Phát hiện tất cả các vé lô tô trong ảnh.\n"
              + "2. Với mỗi vé: \n"
              + "   - Trích xuất đúng 9 số theo thứ tự từ trái sang phải, từ trên xuống dưới.\n"
              + "   - Xác định vòng chơi dựa vào màu nền chính của vé đó.\n\n"
              + "Trả về CHỈ MỘT đối tượng JSON với định dạng sau, không thêm giải thích, markdown hay code block:\n"
              + "{\n"
              + "  \"tickets\": [\n"
              + "    {\n"
              + "      \"numbers\": [\"01\",\"23\",\"45\",\"67\",\"89\",\"12\",\"34\",\"56\",\"78\"],\n"
              + "      \"round\": \"Vòng Xanh Lá\"\n"
              + "    },\n"
              + "    {\n"
              + "      \"numbers\": [\"53\",\"65\",\"79\",\"45\",\"60\",\"77\",\"32\",\"55\",\"72\"],\n"
              + "      \"round\": \"Vòng Đỏ\"\n"
              + "    }\n"
              + "  ]\n"
              + "}\n\n"
              + "Nếu chỉ có 1 vé thì mảng tickets chỉ chứa 1 phần tử.\n"
              + "Nếu không phát hiện vé nào thì tickets là mảng rỗng: []\n"
              + "Chỉ chọn đúng một trong các giá trị vòng sau: "
              + ROUNDS.map(r => `"${r.value}"`).join(", ") + ".\n"
              + "Mỗi số phải là chuỗi 2 chữ số (pad '0' nếu cần)."
          },
          {
            inlineData: {
              mimeType: imageFile.type || 'image/jpeg',
              data: base64Image
            }
          }
        ]
      }
    ],
    generationConfig: {
      temperature: 0.1,       // Giữ thấp để tăng độ chính xác
      topP: 0.8,
      topK: 40,
      maxOutputTokens: 4096   // Tăng lên vì có thể nhiều vé
    }
  };

  const response = await fetch(GEMINI_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Lỗi API: ${response.status} - ${errorText}`);
  }

  const data = await response.json();
  if (!data.candidates || data.candidates.length === 0) {
    throw new Error('Không nhận được phản hồi từ AI');
  }

  let text = data.candidates[0].content.parts[0].text.trim();
  text = text.replace(/^```json\s*|```$/g, '').trim();

  try {
    const result = JSON.parse(text);

    // Kiểm tra định dạng đúng
    if (!result.tickets || !Array.isArray(result.tickets)) {
      throw new Error('Thiếu trường "tickets" hoặc không phải mảng');
    }

    if (result.tickets.length === 0) {
      throw new Error('AI không phát hiện được vé nào trong ảnh');
    }

    // Chuẩn hóa dữ liệu từng vé
    const validTickets = result.tickets.map((ticket, index) => {
      if (!ticket.numbers || !Array.isArray(ticket.numbers) || ticket.numbers.length !== 9 || !ticket.round) {
        console.warn(`Vé thứ ${index + 1} không hợp lệ, bỏ qua`);
        return null;
      }

      const formattedNumbers = ticket.numbers.map(n => String(n).padStart(2, '0'));
      const validRound = ROUNDS.find(r => r.value === ticket.round)?.value || 'Vòng Xanh Dương';

      return {
        numbers: formattedNumbers,
        round: validRound
      };
    }).filter(Boolean); // Loại bỏ vé không hợp lệ

    if (validTickets.length === 0) {
      throw new Error('Tất cả vé phát hiện được đều không hợp lệ');
    }

    return validTickets; // Trả về mảng các vé hợp lệ
  } catch (parseError) {
    throw new Error('Phản hồi không đúng định dạng JSON: ' + text);
  }
};

const createNewTicket = (numbers, group, round) => ({
  id: Date.now() + Math.random().toString(36).substring(2, 9),
  numbers: numbers,
  checked: numbers.map(row => row.map(() => false)),
  ownerGroup: group || 'Vé của tôi',
  round: round || 'Vòng Xanh Dương',
  status: 'Chưa dò',
  winType: null,
});

const checkTicketForWin = (ticket, currentCalledNumbers) => {
  // Tính toán lại toàn bộ ma trận checked dựa TRÊN DUY NHẤT danh sách số hiện tại
  const newChecked = ticket.numbers.map((row) =>
    row.map((num) => currentCalledNumbers.includes(num))
  );

  let winType = null;
  let status = 'Đang dò';

  // Kiểm tra xem tất cả các ô trong mảng 3x3 đã được gọi chưa
  const isFullHouse = newChecked.every(row => row.every(cell => cell === true));
  // Kiểm tra xem có hàng ngang nào có 3 ô đều đã được gọi chưa
  const hasOneRow = newChecked.some(row => row.every(cell => cell === true));

  if (isFullHouse) {
    winType = 'Cả Vé (Full House)';
    status = 'Đã trúng Cả Vé';
  } else if (hasOneRow) {
    winType = 'Chiến Thắng';
    status = 'Đã trúng Hàng';
  } else if (currentCalledNumbers.length > 0) {
    status = 'Đang dò';
  } else {
    status = 'Chưa dò';
  }

  return { checked: newChecked, status, winType };
};

// === COMPONENT CHÍNH ===
const LotoScanner = () => {
  const navigate = useNavigate();

  // State chính
  const [tickets, setTickets] = useState([]);
  const [calledNumbers, setCalledNumbers] = useState([]);
  const [history, setHistory] = useState([]);
  const [customGroups, setCustomGroups] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [ticketToDelete, setTicketToDelete] = useState(null);

  // State UI
  const [newNumberInput, setNewNumberInput] = useState('');
  const [activeTab, setActiveTab] = useState('scan');
  const [selectedGroup, setSelectedGroup] = useState('Vé của tôi');
  const [showNewGroupInput, setShowNewGroupInput] = useState(false);
  const [newGroupName, setNewGroupName] = useState('');
  const [loadingOCR, setLoadingOCR] = useState(false);
  const [ocrMessage, setOcrMessage] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingTicket, setPendingTicket] = useState(null);
  const [filterRound, setFilterRound] = useState('all');

  // --- STATE MỚI CHO BATCH UPLOAD ---
  const [uploadProgress, setUploadProgress] = useState(0); // 0 to 100
  const [isBatchProcessing, setIsBatchProcessing] = useState(false);

  // --- HÀM CẬP NHẬT TRẠNG THÁI VÉ KHI DANH SÁCH SỐ THAY ĐỔI ---
  const updateTicketsStatus = (newCalledNumbers) => {
    setTickets(prev => prev.map(t => {
      const { checked, status, winType } = checkTicketForWin(t, newCalledNumbers);
      return { ...t, checked, status, winType };
    }));
  };

  // --- HÀM XỬ LÝ XÓA VÉ ---
  const requestDeleteTicket = (ticket) => {
    setTicketToDelete(ticket);
    setShowDeleteModal(true);
  };

  const confirmDeleteTicket = () => {
    if (ticketToDelete) {
      setTickets(prev => prev.filter(t => t.id !== ticketToDelete.id));
      setShowDeleteModal(false);
      setTicketToDelete(null);
    }
  };

  // === LOAD DATA FROM LOCALSTORAGE ===
  useEffect(() => {
    try {
      const savedTickets = localStorage.getItem(STORAGE_KEYS.TICKETS);
      if (savedTickets) setTickets(JSON.parse(savedTickets));

      const savedCalled = localStorage.getItem(STORAGE_KEYS.CALLED_NUMBERS);
      if (savedCalled) setCalledNumbers(JSON.parse(savedCalled));

      const savedGroups = localStorage.getItem(STORAGE_KEYS.CUSTOM_GROUPS);
      if (savedGroups) setCustomGroups(JSON.parse(savedGroups));
    } catch (err) {
      console.error('Lỗi load localStorage:', err);
    }
  }, []);

  // === SAVE TO LOCALSTORAGE ===
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEYS.TICKETS, JSON.stringify(tickets));
    } catch (err) {
      console.error('Lỗi lưu tickets:', err);
    }
  }, [tickets]);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEYS.CALLED_NUMBERS, JSON.stringify(calledNumbers));
    } catch (err) {
      console.error('Lỗi lưu calledNumbers:', err);
    }
  }, [calledNumbers]);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEYS.CUSTOM_GROUPS, JSON.stringify(customGroups));
    } catch (err) {
      console.error('Lỗi lưu customGroups:', err);
    }
  }, [customGroups]);

  // --- HÀM XỬ LÝ QUÉT HÀNG LOẠT ---
  const handleBatchOCR = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    setIsBatchProcessing(true);
    setLoadingOCR(true);
    setUploadProgress(0);
    setOcrMessage(`Đang chuẩn bị xử lý ${files.length} tệp...`);

    let successCount = 0;   // Số vé thành công (không phải số file)
    let failCount = 0;      // Số vé thất bại
    const newTicketsList = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      try {
        setOcrMessage(`Đang quét tệp ${i + 1}/${files.length}: ${file.name}`);

        // Gọi hàm batch OCR - trả về mảng các vé trong ảnh
        const detectedTickets = await handleBatchOCRWithMultipleTickets(file);

        // Với mỗi vé được phát hiện trong ảnh
        for (let j = 0; j < detectedTickets.length; j++) {
          const ticketData = detectedTickets[j];
          const flatNumbers = ticketData.numbers;

          if (flatNumbers.length === 9) {
            const lotoNumbers = [
              flatNumbers.slice(0, 3),
              flatNumbers.slice(3, 6),
              flatNumbers.slice(6, 9)
            ];

            const newTicket = createNewTicket(lotoNumbers, selectedGroup, ticketData.round);
            const checkedData = checkTicketForWin(newTicket, calledNumbers);

            newTicketsList.push({ ...newTicket, ...checkedData });
            successCount++;
          } else {
            console.warn(`Vé thứ ${j + 1} trong file ${file.name} không đủ 9 số`);
            failCount++;
          }
        }

        if (detectedTickets.length === 0) {
          console.warn(`Không phát hiện vé nào trong file: ${file.name}`);
          failCount++;
        }
      } catch (error) {
        console.error(`Lỗi xử lý file ${file.name}:`, error);
        setOcrMessage(`❌ Lỗi file ${file.name}: ${error.message || 'Không đọc được vé'}`);
        failCount++;
      }

      // Cập nhật tiến trình dựa trên số file đã xử lý
      setUploadProgress(Math.round(((i + 1) / files.length) * 100));
    }

    // Thêm tất cả vé mới một lần
    if (newTicketsList.length > 0) {
      setTickets(prev => [...prev, ...newTicketsList]);
    }

    // Thông báo kết quả chính xác theo số vé
    const totalProcessed = successCount + failCount;
    setOcrMessage(
      totalProcessed > 0
        ? `✅ Hoàn tất! Đã thêm ${successCount} vé thành công. Thất bại: ${failCount}.`
        : `⚠️ Không thêm được vé nào từ ${files.length} tệp.`
    );

    // Tự động đóng sau 3 giây (tăng thời gian để đọc thông báo)
    setTimeout(() => {
      setIsBatchProcessing(false);
      setLoadingOCR(false);
      setUploadProgress(0);
      setOcrMessage('Chọn ảnh để quét vé mới.');
    }, 3000);

    // Reset input file
    event.target.value = null;
  };

  // === HÀM TÍNH ĐIỂM ƯU TIÊN SẮP XẾP ===
  const getTicketPriority = (ticket) => {
    // 1. Ưu tiên cao nhất: Vé đã trúng (Kinh)
    if (ticket.winType === 'Cả Vé (Full House)') return 1000;
    if (ticket.winType === 'Hàng ngang') return 500;

    // 2. Tính số lượng số đã trúng trong hàng ngang "tốt nhất" của vé
    let maxMatchesInRow = 0;
    ticket.numbers.forEach((row) => {
      const matches = row.filter(num => calledNumbers.includes(num)).length;
      if (matches > maxMatchesInRow) maxMatchesInRow = matches;
    });

    // 3. Ưu tiên theo số lượng số đã trúng (ví dụ: hàng có 2 số xếp trên hàng 1 số)
    let score = maxMatchesInRow * 100;

    // 4. Nếu có số vừa mới gọi nằm trong vé này, cộng thêm điểm ưu tiên nhỏ để đẩy lên nhẹ
    const lastCalled = calledNumbers[calledNumbers.length - 1];
    const hasLastCalled = ticket.numbers.flat().includes(lastCalled);
    if (hasLastCalled) score += 50;

    return score;
  };

  // === VÉ ĐÃ LỌC VÀ SẮP XẾP THÔNG MINH ===
  const filteredAndSortedTickets = useMemo(() => {
    // Bước 1: Lọc theo vòng
    let result = filterRound === 'all'
      ? [...tickets]
      : tickets.filter(t => t.round === filterRound);

    // Bước 2: Sắp xếp
    if (activeTab === 'play') {
      result.sort((a, b) => {
        const priorityA = getTicketPriority(a);
        const priorityB = getTicketPriority(b);

        if (priorityA !== priorityB) {
          return priorityB - priorityA; // Cao xếp trước
        }
        // Nếu bằng điểm nhau, vé nào mới thêm xếp trên
        return b.id - a.id;
      });
    }
    return result;
  }, [tickets, filterRound, calledNumbers, activeTab]);

  // === Danh sách tất cả nhóm ===
  const allGroups = useMemo(() => {
    const fromTickets = [...new Set(tickets.map(t => t.ownerGroup))];
    const unique = [...new Set(['Vé của tôi', ...customGroups, ...fromTickets])];
    return unique;
  }, [tickets, customGroups]);

  // Xử lý nhóm
  const handleGroupChange = (value) => {
    if (value === ADD_NEW_GROUP_OPTION) {
      setShowNewGroupInput(true);
      setSelectedGroup('Vé của tôi');
    } else {
      setShowNewGroupInput(false);
      setSelectedGroup(value);
    }
  };

  const confirmNewGroup = () => {
    const trimmed = newGroupName.trim();
    if (trimmed && !allGroups.includes(trimmed)) {
      setCustomGroups(prev => [...prev, trimmed]);
      setSelectedGroup(trimmed);
    }
    setNewGroupName('');
    setShowNewGroupInput(false);
  };

  // Quét ảnh
  const handleOCRImage = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoadingOCR(true);
    setOcrMessage('Đang xử lý ảnh bằng AI...');

    try {
      const result = await scanLotoTicketWithGemini(file);
      const flatNumbers = result.numbers;
      if (flatNumbers.length < 9) {
        setOcrMessage(`⚠️ Chỉ nhận diện được ${flatNumbers.length} số. Vui lòng chụp lại.`);
        return;
      }

      setPendingTicket({
        flatNumbers,
        numbers2D: [
          flatNumbers.slice(0, 3),
          flatNumbers.slice(3, 6),
          flatNumbers.slice(6, 9)
        ],
        round: result.round,
        group: selectedGroup
      });
      setShowConfirmModal(true);
      setOcrMessage('✅ Đã quét xong! Vui lòng kiểm tra và xác nhận.');
    } catch (error) {
      setOcrMessage(`❌ Lỗi quét ảnh: ${error.message}`);
    } finally {
      setLoadingOCR(false);
      event.target.value = null;
    }
  };

  // Xác nhận thêm vé
  const confirmAddTicket = () => {
    if (!pendingTicket || pendingTicket.flatNumbers.length < 9) return;

    const lotoNumbers = [
      pendingTicket.flatNumbers.slice(0, 3),
      pendingTicket.flatNumbers.slice(3, 6),
      pendingTicket.flatNumbers.slice(6, 9)
    ];

    const newTicket = createNewTicket(lotoNumbers, pendingTicket.group, pendingTicket.round);
    const { checked, status, winType } = checkTicketForWin(newTicket, calledNumbers);

    setTickets(prev => [...prev, { ...newTicket, checked, status, winType }]);
    setShowConfirmModal(false);
    setPendingTicket(null);
    setOcrMessage(`✅ Đã thêm vé thành công! - ${pendingTicket.round} (${pendingTicket.group})`);
  };

  // Gọi số
  const handleCallNumber = (e) => {
    e.preventDefault();
    const num = newNumberInput.trim();
    if (!num || isNaN(num) || calledNumbers.includes(num.padStart(2, '0'))) {
      setNewNumberInput('');
      return;
    }
    const formattedNum = num.padStart(2, '0');
    setCalledNumbers(prev => [...prev, formattedNum]);
    setNewNumberInput('');

    setTickets(prevTickets =>
      prevTickets.map(ticket => {
        const { checked, status, winType } = checkTicketForWin(ticket, [...calledNumbers, formattedNum]);
        return { ...ticket, checked, status, winType };
      })
    );
  };

  // --- XÓA TỪNG SỐ ---
  const removeCalledNumber = (numToRemove) => {
    setHistory([...history, [...calledNumbers]]);
    const newCalled = calledNumbers.filter(n => n !== numToRemove);

    // 1. Cập nhật danh sách số đã gọi (kích hoạt lưu localStorage)
    setCalledNumbers(newCalled);

    // 2. Cập nhật lại toàn bộ vé dựa trên danh sách số mới này
    setTickets(prevTickets =>
      prevTickets.map(ticket => {
        const { checked, status, winType } = checkTicketForWin(ticket, newCalled);
        return { ...ticket, checked, status, winType };
      })
    );
  };

  // --- XÓA TẤT CẢ ---
  const clearAllCalledNumbers = () => {
    if (window.confirm("Bạn có chắc chắn muốn xóa tất cả số đã gọi không?")) {
      setHistory([...history, [...calledNumbers]]);
      setCalledNumbers([]);

      // Reset toàn bộ vé về trạng thái ban đầu (truyền mảng rỗng [])
      setTickets(prevTickets =>
        prevTickets.map(ticket => {
          const { checked, status, winType } = checkTicketForWin(ticket, []);
          return { ...ticket, checked, status, winType };
        })
      );
    }
  };

  // --- HOÀN TÁC / UNDO ---
  const handleUndo = () => {
    if (history.length === 0) return;
    const previousState = history[history.length - 1];
    const newHistory = history.slice(0, -1);

    setCalledNumbers(previousState);
    setHistory(newHistory);

    // Cập nhật lại vé theo trạng thái trước đó
    setTickets(prevTickets =>
      prevTickets.map(ticket => {
        const { checked, status, winType } = checkTicketForWin(ticket, previousState);
        return { ...ticket, checked, status, winType };
      })
    );
  };

  // Style màu vòng
  const getRoundStyle = (round) => {
    const r = ROUNDS.find(item => item.value === round);
    return r ? { backgroundColor: r.color, border: `2px solid ${r.border}` } : {};
  };

  // Vé đã lọc
  const filteredTickets = useMemo(() => {
    if (filterRound === 'all') return tickets;
    return tickets.filter(t => t.round === filterRound);
  }, [tickets, filterRound]);

  // Component vé
  const LotoTicket = useCallback(({ ticket }) => {
    const statusClass = ticket.status.includes('trúng') ? 'ticket-won' : 'ticket-active';
    const roundStyle = getRoundStyle(ticket.round);

    return (
      <div className={`loto-ticket-card ${statusClass}`} style={roundStyle}>
        {/* Nút Xóa Vé ở góc phải */}
        <button
          className="delete-ticket-btn"
          onClick={() => requestDeleteTicket(ticket)}
          title="Xóa vé này"
        >
          🗑️ Xóa
        </button>
        <div className="ticket-header">
          <span className="ticket-group">👤 {ticket.ownerGroup} - {ticket.round}</span>
        </div>
        <div className="ticket-grid">
          {ticket.numbers.map((row, rowIndex) => (
            <div key={rowIndex} className="ticket-row">
              {row.map((num, colIndex) => (
                <span
                  key={colIndex}
                  className={`ticket-cell ${ticket.checked[rowIndex][colIndex] ? 'checked-num' : ''}`}
                >
                  {num}
                </span>
              ))}
            </div>
          ))}
        </div>
        <div className="ticket-footer">
          <span className={`ticket-status ${ticket.winType ? 'status-winning' : ''}`}>
            {ticket.winType ? `🎉 ${ticket.winType}!` : ticket.status}
          </span>
        </div>
      </div>
    );
  }, [calledNumbers]);

  return (
    <div className="loto-scanner-page">
      <header className="loto-header">
        <button onClick={() => navigate('/christmas-event')} className="back-button">
          ← Quay lại
        </button>
        <h1>Dò Lô Tô Thông Minh</h1>
      </header>

      <div className="tab-navigation">
        <button className={`tab-button ${activeTab === 'scan' ? 'active' : ''}`} onClick={() => setActiveTab('scan')}>
          📸 Thêm vé
        </button>
        <button className={`tab-button ${activeTab === 'play' ? 'active' : ''}`} onClick={() => setActiveTab('play')}>
          🔢 Dò số trúng
        </button>
        <button className={`tab-button ${activeTab === 'donate' ? 'active' : ''}`} onClick={() => setActiveTab('donate')}>
          ☕ Ủng hộ
        </button>
      </div>

      <main className="loto-main-content">
        {/* TAB QUẢN LÝ VÉ */}
        {activeTab === 'scan' && (
          <div className="tab-content fade-in">
            <section className="ticket-management-panel">
              <h3>Thêm Vé Mới</h3>

              {/* Select nhóm thông minh */}
              <div className="group-selector-container">
                <select value={selectedGroup} onChange={(e) => handleGroupChange(e.target.value)}>
                  <option value="Vé của tôi">Vé của tôi</option>
                  {allGroups.filter(g => g !== 'Vé của tôi').map(g => (
                    <option key={g} value={g}>{g}</option>
                  ))}
                  <option value={ADD_NEW_GROUP_OPTION}>{ADD_NEW_GROUP_OPTION}</option>
                </select>

                {showNewGroupInput && (
                  <div className="new-group-input-row">
                    <input
                      type="text"
                      placeholder="Nhập tên nhóm mới..."
                      value={newGroupName}
                      onChange={(e) => setNewGroupName(e.target.value)}
                      onKeyDown={(e) => e.key === 'Enter' && confirmNewGroup()}
                      autoFocus
                    />
                    <button onClick={confirmNewGroup}>Thêm</button>
                    <button onClick={() => { setShowNewGroupInput(false); setNewGroupName(''); }} className="cancel">Hủy</button>
                  </div>
                )}
              </div>

              <div className="add-ticket-buttons">
                {/* Nút Quét Đơn (Cũ) */}
                <input type="file" accept="image/*" onChange={handleOCRImage} disabled={loadingOCR} style={{ display: 'none' }} id="ocr-file-input" />
                <label htmlFor="ocr-file-input" className={`ocr-button ${loadingOCR ? 'loading' : ''}`}>
                  📸 Quét Vé Đơn (Xác nhận lại)
                </label>

                {/* NÚT MỚI: TẢI NHIỀU VÉ */}
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleBatchOCR}
                  disabled={loadingOCR}
                  style={{ display: 'none' }}
                  id="batch-file-input"
                />
                <label htmlFor="batch-file-input" className={`batch-button ${loadingOCR ? 'loading' : ''}`}>
                  📥 Tải lên nhiều vé lô tô
                </label>
              </div>

              <div className="ocr-status-message">
                {ocrMessage || 'Chọn ảnh vé rõ nét (thấy rõ màu nền và các số) để quét.'}
              </div>
            </section>

            <section className="loto-tickets-section">
              <h2>Vé của bạn ({tickets.length})</h2>
              <div className="tickets-display-grid">
                {tickets.length === 0 ? (
                  <p className="empty-message">Chưa có vé nào được thêm.</p>
                ) : (
                  tickets.map(ticket => <LotoTicket key={ticket.id} ticket={ticket} />)
                )}
              </div>
            </section>
          </div>
        )}

        {/* TAB DÒ SỐ */}
        {activeTab === 'play' && (
          <div className="tab-content fade-in">
            <section className="loto-control-panel">
              <h3>Nhập Số Đã Gọi</h3>
              <form onSubmit={handleCallNumber} className="number-input-form">
                <input
                  type="text"
                  placeholder="Nhập số (1-90)"
                  value={newNumberInput}
                  onChange={(e) => setNewNumberInput(e.target.value.replace(/\D/g, '').slice(0, 2))}
                  maxLength="2"
                  inputMode="numeric"
                />
                <button type="submit" className="call-button">GỌI SỐ</button>
              </form>

              <div className="called-numbers-list">
                <h4>Đã gọi ({calledNumbers.length}):</h4>
                <div className="control-buttons">
                  <button className="undo-btn" onClick={handleUndo} disabled={history.length === 0} title="Hoàn tác">
                    ↩ Hoàn tác
                  </button>
                  <button className="clear-all-btn" onClick={clearAllCalledNumbers} disabled={calledNumbers.length === 0}>
                    🗑️ Xóa tất cả để chơi vòng mới
                  </button>
                </div>
                <div className="numbers-tag-container">
                  {calledNumbers.slice().reverse().map((num, i) => (
                    <span key={num} className={`number-tag ${i === 0 ? 'last-called' : ''}`}>
                      {num}
                      <button className="remove-num-btn" onClick={() => removeCalledNumber(num)}>×</button>
                    </span>
                  ))}
                </div>
              </div>
            </section>

            <section className="loto-tickets-section">
              <div className="filter-round-container">
                <label>Lọc vòng: </label>
                <select value={filterRound} onChange={(e) => setFilterRound(e.target.value)}>
                  <option value="all">Tất cả</option>
                  {ROUNDS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </div>

              <h3>Danh sách theo dõi ({filteredAndSortedTickets.length})</h3>
              <p style={{ fontSize: '0.8em', color: '#666', marginBottom: '10px' }}>* Vé sắp kinh sẽ tự động nhảy lên đầu.</p>

              <div className="tickets-display-grid">
                {filteredAndSortedTickets.map(ticket => (
                  <LotoTicket key={ticket.id} ticket={ticket} />
                ))}
              </div>
            </section>
          </div>
        )}

        {/* NỘI DUNG TAB ỦNG HỘ */}
        {activeTab === 'donate' && (
          <div className="tab-content fade-in donate-section">
            <div className="donate-card">
              <div className="donate-icon">🎁</div>
              <h2>Ủng hộ nhà phát triển</h2>
              <p>Nếu ứng dụng này giúp bạn có một mùa Giáng Sinh vui vẻ và tiện lợi hơn, hãy mời mình một ly cà phê nhé!</p>
              <div className="qr-container">
                {/* Bạn hãy thay link ảnh QR ngân hàng của bạn vào đây */}
                <img
                  src="https://api.vietqr.io/image/970416-7624897-xvYC6jO.jpg?accountName=DO%20NHAT%20TAI"
                  alt="QR Quyên góp"
                  className="bank-qr"
                />
                {/* NÚT TẢI ẢNH MỚI THÊM */}
                <div className="donate-action-buttons">
                  <button className="download-qr-btn" onClick={downloadQR}>
                    📥 Tải ảnh QR về máy
                  </button>

                </div>
                <p className="bank-info">
                  <strong>Ngân hàng:</strong> ACB - Ngân hàng Á Châu<br />
                  <strong>Số tài khoản:</strong> 7624897<br />
                  <strong>Chủ tài khoản:</strong> DO NHAT TAI
                  <button className="copy-btn" onClick={() => {
                    navigator.clipboard.writeText("7624897");
                    alert("Đã sao chép số tài khoản!");
                  }}>
                    📋 Sao chép STK
                  </button>
                </p>
              </div>

              <div className="thank-you-message">
                <p>🙏 Chân thành cảm ơn sự ủng hộ của bạn. Chúc bạn một mùa Giáng Sinh an lành và trúng thật nhiều quà!</p>
              </div>
            </div>
          </div>
        )}
      </main>

      {/* --- MODAL TIẾN TRÌNH XỬ LÝ HÀNG LOẠT --- */}
      {isBatchProcessing && (
        <div className="modal-overlay">
          <div className="modal-content progress-modal">
            <h3>Đang xử lý hàng loạt</h3>
            <p>{ocrMessage}</p>
            <div className="progress-container">
              <div
                className="progress-bar"
                style={{ width: `${uploadProgress}%` }}
              >
                {uploadProgress}%
              </div>
            </div>
            <p className="sub-text">Vui lòng không đóng trình duyệt...</p>
          </div>
        </div>
      )}

      {/* MODAL XÁC NHẬN XÓA VÉ */}
      {showDeleteModal && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Xác nhận xóa vé</h3>
            <p>Bạn có chắc chắn muốn xóa vé thuộc <strong>{ticketToDelete?.ownerGroup}</strong> này không?</p>
            <div className="modal-buttons" style={{ marginTop: '20px' }}>
              <button className="cancel-button" onClick={() => setShowDeleteModal(false)}>Hủy</button>
              <button
                className="confirm-button"
                style={{ backgroundColor: '#dc3545' }}
                onClick={confirmDeleteTicket}
              >
                Xác nhận xóa
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL XÁC NHẬN */}
      {showConfirmModal && pendingTicket && (
        <div className="modal-overlay" onClick={() => setShowConfirmModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Xác nhận vé đã quét</h3>
            <p>Vui lòng kiểm tra lại số và thông tin:</p>

            <div className="edit-grid" style={getRoundStyle(pendingTicket.round)}>
              {pendingTicket.numbers2D.map((row, i) => (
                <div key={i} className="ticket-row" style={{ justifyContent: 'center', gap: '10px', marginBottom: '10px' }}>
                  {row.map((num, j) => (
                    <input
                      key={j}
                      type="text"
                      maxLength="2"
                      className="edit-cell"
                      value={num}
                      onChange={(e) => {
                        let value = e.target.value.replace(/\D/g, '').slice(0, 2).padStart(2, '0');
                        const newFlat = [...pendingTicket.flatNumbers];
                        newFlat[i * 3 + j] = value;
                        setPendingTicket(prev => ({
                          ...prev,
                          flatNumbers: newFlat,
                          numbers2D: [
                            newFlat.slice(0, 3),
                            newFlat.slice(3, 6),
                            newFlat.slice(6, 9)
                          ]
                        }));
                      }}
                    />
                  ))}
                </div>
              ))}
            </div>

            <div className="modal-group-select">
              <label>Nhóm:</label>
              <select
                value={pendingTicket.group}
                onChange={(e) => setPendingTicket(prev => ({ ...prev, group: e.target.value }))}
              >
                <option value="Vé của tôi">Vé của tôi</option>
                {allGroups.filter(g => g !== 'Vé của tôi').map(g => (
                  <option key={g} value={g}>{g}</option>
                ))}
              </select>
            </div>

            <div className="modal-round-select">
              <label>Vòng chơi:</label>
              <select
                value={pendingTicket.round}
                onChange={(e) => setPendingTicket(prev => ({ ...prev, round: e.target.value }))}
              >
                {ROUNDS.map(r => (
                  <option key={r.value} value={r.value}>{r.label}</option>
                ))}
              </select>
            </div>

            <div className="modal-buttons">
              <button className="cancel-button" onClick={() => setShowConfirmModal(false)}>Hủy</button>
              <button className="confirm-button" onClick={confirmAddTicket}>Xác nhận thêm vé</button>
            </div>
          </div>
        </div>

      )}
    </div>
  );
};

export default LotoScanner;